// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-page {
    min-height: 100vh;
    background: #f5f5f5;
    padding: 60px 20px;
}

.privacy-container {
    max-width: 760px;
    margin: 0 auto;
    background: white;
    border-radius: 12px;
    padding: 48px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.privacy-container h1 {
    font-size: 32px;
    color: #0a66c2;
    margin-bottom: 4px;
}

.privacy-updated {
    color: #888;
    font-size: 14px;
    margin-bottom: 36px;
}

.privacy-container section {
    margin-bottom: 32px;
}

.privacy-container h2 {
    font-size: 18px;
    color: #1a1a1a;
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 1px solid #eee;
}

.privacy-container p {
    color: #444;
    line-height: 1.7;
    margin-bottom: 10px;
}

.privacy-container ul {
    padding-left: 20px;
    color: #444;
    line-height: 1.9;
}

.privacy-container a {
    color: #0a66c2;
    text-decoration: none;
}

.privacy-container a:hover {
    text-decoration: underline;
}

.privacy-back {
    margin-top: 40px;
    padding-top: 24px;
    border-top: 1px solid #eee;
}

.privacy-back a {
    font-size: 14px;
    color: #0a66c2;
}
`, "",{"version":3,"sources":["webpack://./src/components/Privacy.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB","sourcesContent":[".privacy-page {\n    min-height: 100vh;\n    background: #f5f5f5;\n    padding: 60px 20px;\n}\n\n.privacy-container {\n    max-width: 760px;\n    margin: 0 auto;\n    background: white;\n    border-radius: 12px;\n    padding: 48px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n}\n\n.privacy-container h1 {\n    font-size: 32px;\n    color: #0a66c2;\n    margin-bottom: 4px;\n}\n\n.privacy-updated {\n    color: #888;\n    font-size: 14px;\n    margin-bottom: 36px;\n}\n\n.privacy-container section {\n    margin-bottom: 32px;\n}\n\n.privacy-container h2 {\n    font-size: 18px;\n    color: #1a1a1a;\n    margin-bottom: 10px;\n    padding-bottom: 6px;\n    border-bottom: 1px solid #eee;\n}\n\n.privacy-container p {\n    color: #444;\n    line-height: 1.7;\n    margin-bottom: 10px;\n}\n\n.privacy-container ul {\n    padding-left: 20px;\n    color: #444;\n    line-height: 1.9;\n}\n\n.privacy-container a {\n    color: #0a66c2;\n    text-decoration: none;\n}\n\n.privacy-container a:hover {\n    text-decoration: underline;\n}\n\n.privacy-back {\n    margin-top: 40px;\n    padding-top: 24px;\n    border-top: 1px solid #eee;\n}\n\n.privacy-back a {\n    font-size: 14px;\n    color: #0a66c2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
